export * as integrationWizardApiSlice from './api/integrationWizardSlice';

export { integrationErrorMap } from './components/VerificationError';

export type { default as VerificationResult } from './VerificationResult';

export { default as useWizardSteps } from './useWizardSteps';

export { CodeToPath, FULL_WIZARD_STEPS, StepCodes } from './steps';

export { WizardColumn, WizardGutterProvider, useWizardGutter } from './WizardGutter';

import OnboardingSurveyStep from './components/steps/OnboardingSurveyStep/OnboardingSurveyStep';
import InviteTeamStep from './components/steps/InviteTeamStep/InviteTeamStep';
import IntegrationStep from './components/steps/IntegrationStep/IntegrationStep';
import VerifyDomainStep from './components/steps/VerifyDomainStep';
import VerifySuccessfulStep from './components/steps/VerificationSuccessfulStep';

export const WizardSteps = {
  Personalisation: OnboardingSurveyStep,
  InviteTeam: InviteTeamStep,
  Integrate: IntegrationStep,
  VerifyIntegration: VerifyDomainStep,
  StartRendering: VerifySuccessfulStep,
};
